import { Component, OnInit, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { ListComponent, UserGroup, User, UserRepositoryService } from 'reg-hub-common';
import { Router } from '@angular/router';
import { HttpParams } from '@angular/common/http';

@Component({
    selector: 'app-users-list',
    templateUrl: './users-list.component.html',
    styleUrls: ['./users-list.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UsersListComponent extends ListComponent<User> {
    @Input() userGroup!: UserGroup;

    displayedColumns: string[] = ['userName',
    'name',
    'email',
    'type',
    'configuration'];
    
    constructor(repo: UserRepositoryService,
        private router: Router) {
          super(repo);
    }

    navigateToAddUser() {
        this.router.navigate(['management', 'userGroups', this.userGroup.id, 'users', 'add']);
    }
}